"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const react_1 = require("react");
const Wrap = app_1.styled.div `
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  padding: ${(theme) => `calc(${theme.spacing.extraSmall} / 2) ${theme.spacing.extraSmall}`};
  border-radius: ${(theme) => theme.radius.big};
  background: ${(theme, { $kind }) => $kind === 'gray' ? theme.colors.gray.intense : theme.colors[$kind]};
  color: ${(theme, { $kind }) => $kind === 'gray' ? theme.colors.gray.light : theme.colors[$kind].intense};
  @media ${app_1.mobile} {
    ${(_, { $mobileDot }) => $mobileDot &&
    (0, app_1.css) `
        padding: ${(theme) => `calc(${theme.spacing.small} / 2)`};
        > span {
          display: none;
        }
      `}
  }
`;
const Text = app_1.styled.span `
  font-weight: 700;
  font-size: 0.8125rem;
  letter-spacing: 0.015625rem;
  line-height: 100%;
`;
const RemoveButton = app_1.styled.button `
  padding: 0;
  color: ${(theme) => theme.colors.gray};
  &:hover {
    color: ${(theme) => theme.colors.primary.deep};
  }
  > svg {
    width: 1rem !important;
  }
`;
const styles = {
    TagText: {
        remove: (0, app_1.css) `
      margin-right: ${(theme) => theme.spacing.extraSmall};
    `,
    },
};
function Tag({ kind = 'gray', remove, children, mobileDot, className, }) {
    const textCss = (0, react_1.useMemo)(() => (remove ? styles.TagText.remove : undefined), [remove]);
    return ((0, jsx_runtime_1.jsxs)(Wrap, Object.assign({ className: className, "$kind": kind, "$mobileDot": Boolean(mobileDot) }, { children: [(0, jsx_runtime_1.jsx)(Text, Object.assign({ css: textCss }, { children: children })), remove && ((0, jsx_runtime_1.jsx)(RemoveButton, Object.assign({ onClick: remove }, { children: (0, jsx_runtime_1.jsx)(svg_1.SvgCloseMenu, {}) })))] })));
}
exports.Tag = Tag;
